/** Shared spacing token for stacked form fields (MUI spacing units). */
export const FORM_FIELD_GAP = 2;
